import { createRouter, createMemoryHistory } from 'vue-router'
import Layout from '@/views/LayoutShell'
import { routerGuard } from '@/dashboards/'
import { pages } from 'frontendcommon-3'

const {
  PageNotFound
} = pages

const routes = [
  {
    path: '/',
    component: Layout,
    name: 'root',
    children: [
      {
        path: '',
        name: 'root-child',
        meta: { requireAuth: true },
        component: () => import(/* webpackChunkName: "homeView" */ '../views/Home')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error404',
    component: PageNotFound
  }
]

const router = createRouter({
  history: createMemoryHistory(),
  routes
})
router.beforeEach(routerGuard(router))

export default router
